import React, { useState, useEffect } from 'react';
import '../../pages/About/AboutPage.css'
import { Link } from 'react-router-dom';
import cv from '../../cv/cv.pdf';
import { ButtomGet } from '../ButtomGet/ButtomGet';

/* Multi idioma */
import { FormattedMessage } from 'react-intl';

const About = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        setIsVisible(true);
        return () => setIsVisible(false);
    }, []);

    return (
        <section className={`sobre-mi ${isVisible ? 'visible' : ''}`} id="sobre-mi">
            <h2 className="heading" data-aos="fade-down" data-aos-duration="800">
                <FormattedMessage
                    id='about'
                    defaultMessage='About me'
                />
            </h2>

            <div className="row container">
                <div className="columns about-card" data-aos="fade-right" data-aos-delay="300" data-aos-duration="1000">
                    <div className="profile-header">
                        <h3>
                            <FormattedMessage
                                id='im'
                                defaultMessage='who I am'
                            />
                        </h3>
                        <div className="animated-underline"></div>
                    </div>
                    <h4 className="intro-text">
                        <FormattedMessage
                            id='description'
                            defaultMessage='My Name is Arun Singh and I am a Python Full Stack & Web Developer.'
                        />
                    </h4>
                    <p className="description-text">
                        <FormattedMessage
                            id='my-description'
                            defaultMessage='Aspiring full-stack developer with hands-on experience in React, Django, and C#, passionate about building real-world projects and continuously learning.'
                        />
                    </p>
                    <ul className="info-list">
                        <li>
                            <p>
                                <span>
                                    <FormattedMessage
                                        id='years'
                                        defaultMessage='Age:'
                                    />
                                </span> 23
                            </p>
                        </li>
                        <li>
                            <p>
                                <span>
                                    Hobbies:{" "}
                                </span>
                                    Playing Online Games, Watch Tech Talks and Programming
                            </p>
                        </li>
                        <li>
                            <p><span>Email:</span> chyarun727@gmail.com</p>
                        </li>
                        <li>
                            <p>
                                <span>
                                    <FormattedMessage
                                        id='from'
                                        defaultMessage='From:'
                                    /> 
                                </span>  India
                            </p>
                        </li>
                    </ul>
                    <div className="mas-info">
                        <a href={cv} target="_blank" rel="noopener noreferrer" download="Arun singh Resume" className="btn-codigo buttonDownload">
                            <FormattedMessage
                                id='btn-cv'
                                defaultMessage='Download CV'
                            />
                        </a>
                        <div className='mas-info-btn'>
                        <Link to="/about">
                            <ButtomGet/>
                        </Link>
                        </div>
                    </div>
                </div>
                <div className="columns col-skill skills-card" data-aos="fade-left" data-aos-delay="650" data-aos-duration="1000">
                    <div className="skills-header">
                        <h3>skills</h3>
                        <div className="animated-underline"></div>
                    </div>
                    <h4>Front-End</h4>
                    <div className="skill">
                        {[
                            { name: "HTML5", icon: "https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original.svg" },
                            { name: "CSS3", icon: "https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original.svg" },
                            { name: "JavaScript", icon: "https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-plain.svg" },
                            { name: "TailWind", icon: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/Tailwind_CSS_Logo.svg/1024px-Tailwind_CSS_Logo.svg.png?20230715030042" },
                            { name: "Bootstrap", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-original.svg" },
                            { name: "jQuery", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jquery/jquery-plain-wordmark.svg" },
                            { name: "React", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg" },
                            { name: "Typescript", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg" }
                        ].map((tech, index) => (
                            <div key={index} className="skill-item" data-aos="zoom-in" data-aos-delay={index * 100}>
                                <img alt={tech.name} className="icons-skils" src={tech.icon} />
                                <h5>{tech.name}</h5>
                            </div>
                        ))}
                    </div>
                    <h4>Back-End</h4>
                    <div className="skill">
                        {[
                            { name: "Django", icon: "https://1000logos.net/wp-content/uploads/2020/08/Django-Logo.png" },
                            { name: "C Sharp", icon: "https://th.bing.com/th/id/OIP.HQLxosIyu6iDZUjTmxYkHAHaH9?rs=1&pid=ImgDetMain&cb=idpwebpc2" },
                            { name: "NodeJs", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg" },
                            { name: "Python", icon: "https://logos-download.com/wp-content/uploads/2016/10/Python_logo_icon.png" },
                            { name: "MySQL", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/mysql/mysql-original-wordmark.svg" },
                            { name: "PostgreSQL", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/postgresql/postgresql-original-wordmark.svg" },
                            { name: "MongodDB", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-plain-wordmark.svg" }
                        ].map((tech, index) => (
                            <div key={index} className="skill-item" data-aos="zoom-in" data-aos-delay={index * 100 + 300}>
                                <img alt={tech.name} className="icons-skils" src={tech.icon} />
                                <h5>{tech.name}</h5>
                            </div>
                        ))}
                    </div>
                    <h4>
                        <FormattedMessage
                            id='tools'
                            defaultMessage='Tools'
                        />
                    </h4>
                    <div className="skill">
                        {[
                            { name: "GitHub", icon: "https://pngimg.com/uploads/github/github_PNG40.png" },
                            { name: "NPM", icon: "https://logodix.com/logo/1974428.png" },
                            { name: "VS Code", icon: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2d/Visual_Studio_Code_1.18_icon.svg/1200px-Visual_Studio_Code_1.18_icon.svg.png" },
                            { name: "Git", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg" }
                        ].map((tech, index) => (
                            <div key={index} className="skill-item" data-aos="zoom-in" data-aos-delay={index * 100 + 600}>
                                <img alt={tech.name} className="icons-skils" src={tech.icon} />
                                <h5>{tech.name}</h5>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default React.memo(About);